import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';
import { ValidationUtils } from '../Sidebar/Common';

import LoadingOverlay from "./LoadingOverlay";
export default class Import_queue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.import_queue_Id,
          sortable: true,
          cell: (row) => <span>{row.import_queue_Id}</span>,
        },
        { name: "Import Session Id", selector: (row, i) => row.import_session_id, sortable: true, cell: (row) => <span>{row.import_session_id}</span>, }, { name: "Priority", selector: (row, i) => row.priority, sortable: true, cell: (row) => <span>{row.priority}</span>, }, { name: "Status", selector: (row, i) => row.status, sortable: true, cell: (row) => <span>{row.status}</span>, }, { name: "Retry Count", selector: (row, i) => row.retry_count, sortable: true, cell: (row) => <span>{row.retry_count}</span>, }, { name: "Max Retries", selector: (row, i) => row.max_retries, sortable: true, cell: (row) => <span>{row.max_retries}</span>, }, { name: "Scheduled At", selector: (row, i) => row.scheduled_at, sortable: true, cell: (row) => <span>{row.scheduled_at}</span>, }, { name: "Started At", selector: (row, i) => row.started_at, sortable: true, cell: (row) => <span>{row.started_at}</span>, }, { name: "Completed At", selector: (row, i) => row.completed_at, sortable: true, cell: (row) => <span>{row.completed_at}</span>, }, { name: "Error Message", selector: (row, i) => row.error_message, sortable: true, cell: (row) => <span>{row.error_message}</span>, },

        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.Import_queueeditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      import_queue_Id: "",
      import_session_id: '', bulkimportprioritymaster: [], priority: '', bulkimportstatusmaster: [], status: '', retry_count: '', max_retries: '', scheduled_at: '', started_at: '', completed_at: '', error_message: '',

    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case 'text':
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case 'mail':
      case 'email':
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case 'telephone':
      case 'phone':
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case 'number':
        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);
        break;

      case 'dob_child':
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case 'dob_adult':
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case 'pan':
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case 'aadhaar':
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case 'password':
        if (value.length < 6) {
          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {
      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true }
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true }
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined


    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      { fieldName: 'import_session_id', inputType: 'Number', displayName: 'Import Session Id', validationOptions: { isRequired: false } },
      { fieldName: 'priority', inputType: 'Select', displayName: 'Priority', validationOptions: { isRequired: false } },
      { fieldName: 'status', inputType: 'Select', displayName: 'Status', validationOptions: { isRequired: false } },
      { fieldName: 'retry_count', inputType: 'Number', displayName: 'Retry Count', validationOptions: { isRequired: false } },
      { fieldName: 'max_retries', inputType: 'Number', displayName: 'Max Retries', validationOptions: { isRequired: false } },
      { fieldName: 'scheduled_at', inputType: 'Date', displayName: 'Scheduled At', validationOptions: { isRequired: false } },
      { fieldName: 'started_at', inputType: 'Date', displayName: 'Started At', validationOptions: { isRequired: false } },
      { fieldName: 'completed_at', inputType: 'Date', displayName: 'Completed At', validationOptions: { isRequired: false } },
      { fieldName: 'error_message', inputType: 'Text', displayName: 'Error Message', validationOptions: { isRequired: false } }
    ];

    fieldConfigs.forEach(config => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach(config => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });

  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      import_session_id: '', bulkimportprioritymaster: [], priority: '', bulkimportstatusmaster: [], status: '', retry_count: '', max_retries: '', scheduled_at: '', started_at: '', completed_at: '', error_message: '',
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      import_session_id: '', bulkimportprioritymaster: [], priority: '', bulkimportstatusmaster: [], status: '', retry_count: '', max_retries: '', scheduled_at: '', started_at: '', completed_at: '', error_message: '',
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  Import_queueeditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      import_queue_Id: row.import_queue_Id,
      import_session_id: row.import_session_id, bulkimportprioritymaster: [], priority: row.priority, bulkimportstatusmaster: [], status: row.status, retry_count: row.retry_count, max_retries: row.max_retries, scheduled_at: row.scheduled_at, started_at: row.started_at, completed_at: row.completed_at, error_message: row.error_message,

      errors: {},
      touched: {}
    });
  }

  Import_queuefetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + 'C_Import_queue/list', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  }

  Import_queuesubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('import_session_id', this.state.import_session_id);
    formData.append('priority', this.state.priority);
    formData.append('status', this.state.status);
    formData.append('retry_count', this.state.retry_count);
    formData.append('max_retries', this.state.max_retries);
    formData.append('scheduled_at', this.state.scheduled_at);
    formData.append('started_at', this.state.started_at);
    formData.append('completed_at', this.state.completed_at);
    formData.append('error_message', this.state.error_message);



    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Import_queue/add', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Import_queuefetchHandler();
          this.handleOffcanvasClose();
          this.setState({ import_session_id: '', bulkimportprioritymaster: [], priority: '', bulkimportstatusmaster: [], status: '', retry_count: '', max_retries: '', scheduled_at: '', started_at: '', completed_at: '', error_message: '', });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });});
  }

  Import_queueupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("import_queue_Id", this.state.import_queue_Id);
    formData.append('import_session_id', this.state.import_session_id);
    formData.append('priority', this.state.priority);
    formData.append('status', this.state.status);
    formData.append('retry_count', this.state.retry_count);
    formData.append('max_retries', this.state.max_retries);
    formData.append('scheduled_at', this.state.scheduled_at);
    formData.append('started_at', this.state.started_at);
    formData.append('completed_at', this.state.completed_at);
    formData.append('error_message', this.state.error_message);



    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Import_queue/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Import_queuefetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });});
  }

  componentDidMount() {
    this.Import_queuefetchHandler();
    this.bulkimportprioritymasterfetchHandler();
    this.bulkimportstatusmasterfetchHandler();


  }

  handleimport_session_idChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ import_session_id: fieldValue });
  }; handlepriorityChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ priority: fieldValue });
  }; bulkimportprioritymasterfetchHandler = () => {
    fetch(configData.api_url + "C_Bulkimportprioritymaster/list", {  // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ bulkimportprioritymaster: data.list });
        }
      });
  }; handlestatusChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ status: fieldValue });
  }; bulkimportstatusmasterfetchHandler = () => {
    fetch(configData.api_url + "C_Bulkimportstatusmaster/list", {  // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ bulkimportstatusmaster: data.list });
        }
      });
  }; handleretry_countChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ retry_count: fieldValue });
  }; handlemax_retriesChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ max_retries: fieldValue });
  }; handlescheduled_atChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ scheduled_at: fieldValue });
  }; handlestarted_atChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ started_at: fieldValue });
  }; handlecompleted_atChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ completed_at: fieldValue });
  }; handleerror_messageChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ error_message: fieldValue });
  };


  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (!window.confirm(`Are you sure you want to delete this import_queue?`)) {
      return;
    }

    var formData = new FormData();
    formData.append('import_queue_Id', row.import_queue_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Import_queue/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Import_queuefetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case 'dob_child':
      case 'dob_adult':
      case 'date':
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case 'telephone':
      case 'phone':
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case 'mail':
      case 'email':
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case 'password':
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case 'number':
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case 'pan':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case 'aadhaar':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && <span className="text-danger">*</span>}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Import Queue</h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Import_queue</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>

                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>Please fix the following errors:</strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(([field, error]) => (
                                    <li key={field}>{error}</li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Import Session Id</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handleimport_session_idChange} className="form-control" name="import_session_id" value={this.state.import_session_id} required="required" placeholder="Enter import_session_id" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.import_session_id} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Priority</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select className="form-select" name="tableName" onChange={this.handlepriorityChange}>
                                        <option defaultValue> Select Priority </option>
                                        {this.state.bulkimportprioritymaster.map((api, index, idx) => (
                                          <option key={index} value={api.high}> {api.high} </option>
                                        ))}
                                      </select>
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.priority} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Status</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select className="form-select" name="tableName" onChange={this.handlestatusChange}>
                                        <option defaultValue> Select Status </option>
                                        {this.state.bulkimportstatusmaster.map((api, index, idx) => (
                                          <option key={index} value={api.uploaded}> {api.uploaded} </option>
                                        ))}
                                      </select>
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.status} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Retry Count</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handleretry_countChange} className="form-control" name="retry_count" value={this.state.retry_count} required="required" placeholder="Enter retry_count" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.retry_count} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Max Retries</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlemax_retriesChange} className="form-control" name="max_retries" value={this.state.max_retries} required="required" placeholder="Enter max_retries" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.max_retries} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Scheduled At</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handlescheduled_atChange} className="form-control" name="scheduled_at" value={this.state.scheduled_at} required="required" placeholder="Enter scheduled_at" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.scheduled_at} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Started At</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handlestarted_atChange} className="form-control" name="started_at" value={this.state.started_at} required="required" placeholder="Enter started_at" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.started_at} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Completed At</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handlecompleted_atChange} className="form-control" name="completed_at" value={this.state.completed_at} required="required" placeholder="Enter completed_at" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.completed_at} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Error Message</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleerror_messageChange} className="form-control" name="error_message" value={this.state.error_message} required="required" placeholder="Enter error_message" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.error_message} </div>
                                  </Row><br />
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.Import_queuesubmitHandler}
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Import_queue</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ "overflowY": "auto", height: "auto" }}>

                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>Please fix the following errors:</strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Import Session Id</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handleimport_session_idChange} className="form-control" name="import_session_id" value={this.state.import_session_id} required="required" placeholder="Enter import_session_id" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.import_session_id} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Priority</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select className="form-select" name="tableName" onChange={this.handlepriorityChange}>
                                          <option defaultValue> Select Priority </option>
                                          {this.state.bulkimportprioritymaster.map((api, index, idx) => (
                                            <option key={index} value={api.high}> {api.high} </option>
                                          ))}
                                        </select>
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.priority} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Status</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select className="form-select" name="tableName" onChange={this.handlestatusChange}>
                                          <option defaultValue> Select Status </option>
                                          {this.state.bulkimportstatusmaster.map((api, index, idx) => (
                                            <option key={index} value={api.uploaded}> {api.uploaded} </option>
                                          ))}
                                        </select>
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.status} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Retry Count</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handleretry_countChange} className="form-control" name="retry_count" value={this.state.retry_count} required="required" placeholder="Enter retry_count" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.retry_count} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Max Retries</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlemax_retriesChange} className="form-control" name="max_retries" value={this.state.max_retries} required="required" placeholder="Enter max_retries" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.max_retries} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Scheduled At</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handlescheduled_atChange} className="form-control" name="scheduled_at" value={this.state.scheduled_at} required="required" placeholder="Enter scheduled_at" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.scheduled_at} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Started At</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handlestarted_atChange} className="form-control" name="started_at" value={this.state.started_at} required="required" placeholder="Enter started_at" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.started_at} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Completed At</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handlecompleted_atChange} className="form-control" name="completed_at" value={this.state.completed_at} required="required" placeholder="Enter completed_at" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.completed_at} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Error Message</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleerror_messageChange} className="form-control" name="error_message" value={this.state.error_message} required="required" placeholder="Enter error_message" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.error_message} </div>
                                    </Row><br />
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.Import_queueupdateHandler}
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <Button
                        variant="primary"
                        className="bi bi-plus"
                        style={{ float: "right", marginBottom: "10px" }}
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}